export default __webpack_public_path__ + "static/media/survey_01.099b6851.png";